import { CompanyType } from "@/interfaces/domain/CompanyType";
import { api } from "@/services/api";

export async function getCompanyTypesRequest() {
  const { data } = await api.get<CompanyType[]>("/tipos-cnpj-cliente");
  return data;
}
